import { useState } from "react";
import type { ColumnTypeFn } from "../types";
import { JsonEditor } from "../../../../jsoneditor";
import { Modal } from "../../../utils/modal";

function JsonPreview({ value }: { value: any }) {
  const [open, setOpen] = useState(false);
  const label =
    typeof value === "object" && value !== null && !Array.isArray(value) && value.name
      ? value.name
      : null;
  const preview = label ?? JSON.stringify(value);
  const truncated = label ?? (preview.length > 80 ? preview.slice(0, 80) + "…" : preview);

  return (
    <>
      <span className="lt-json-preview" onClick={() => setOpen(true)}>
        {truncated}
      </span>
      <Modal show={open} onClose={() => setOpen(false)} title="JSON" size="md">
        <JsonEditor
          value={value}
          mode="view"
          navigationBar={false}
          search={true}
          statusBar={false}
          mainMenuBar={false}
        />
      </Modal>
    </>
  );
}

export const jsonType: ColumnTypeFn = (value) => {
  if (value == null) return <span className="text-muted">-</span>;
  if (typeof value !== "object") return <>{String(value)}</>;
  return <JsonPreview value={value} />;
};
